import * as actions from "./common.actions";
import { Currency } from "./constants";

interface ICommonState {
  darkMode: boolean;
  zoom: number;
  currency: Currency;
  conversionRate: number;
}

const initialState: ICommonState = {
  darkMode: false,
  zoom: 1,
  currency: "DIN",
  conversionRate: 0,
};

export const commonReducer = (
  state: ICommonState = initialState,
  action: any
): ICommonState => {
  switch (action.type) {
    case actions.CHANGE_DARK_MODE:
      return {
        ...state,
        darkMode: action.darkMode,
      };

    case actions.SET_ZOOM:
      return {
        ...state,
        zoom: action.zoom,
      };

    case actions.SET_CURRENCY:
      return {
        ...state,
        currency: action.currency,
      };

    case actions.SET_CONVERSION_RATE:
      return {
        ...state,
        conversionRate: action.conversionRate,
      };

    default:
      return state;
  }
};
